module.exports = __webpack_public_path__ + "img/poll-answer.8514481b.svg";